import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactCadencePolicyCard from './ContactCadencePolicyCard';

// Configuración / Settings — lean tenant settings page.
//
// Reachable at /settings (App.js) from the ADMINISTRAR sidebar entry for
// admin/super_admin (editable) and manager (read-only, enforced by the card).
//
// Why a new page instead of routing the legacy pages/Settings.js: that file
// still carries dead sections (Twilio/OpenAI/Server credential inputs that are
// never persisted and a simulated "Probar" connection test). Exposing those to
// the team would be misleading, so only the live tenant-level configuration is
// mounted here. Add further real settings cards below as they ship.
function SettingsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-foreground sm:text-3xl sm:truncate">
            {t('settings.title')}
          </h2>
          <p className="mt-1 text-sm" style={{ color: 'var(--muted)' }}>
            {t('settings.subtitle')}
          </p>
        </div>
      </div>

      {/* Contact cadence policy (Postventa) — client call Oct 19, José / Grupo Cruces */}
      <ContactCadencePolicyCard />
    </div>
  );
}

export default SettingsPage;
